import { memo, ReactNode, useCallback } from 'react';
import { MapBox } from '../MapBox';
import { useMapboxErrorDetection } from './hooks/useMapboxErrorDetection';
import { LatLng } from './types';

interface MapboxViewProps {
    apiKey: string;
    center: LatLng;
    zoom?: number;
    bounds?: [number, number, number, number] | null;
    children?: ReactNode | ReactNode[];
    onLoaded: (map: any) => void;
    onCenterChanged?: (center: LatLng) => void;
    onFatalError: (reason: string) => void;
}

const MapboxView = ({
    apiKey,
    center,
    zoom,
    bounds,
    children,
    onLoaded,
    onCenterChanged,
    onFatalError,
}: MapboxViewProps) => {
    const { handler: errorHandler } = useMapboxErrorDetection({ onFatalError });

    const handleMapsLoaded = useCallback((map: any) => {
        if (!map) return;

        if (typeof map.on === 'function') {
            map.on('error', errorHandler);
        }

        onLoaded(map);
    }, [errorHandler, onLoaded]);

    return (
        <MapBox
            apiKey={apiKey}
            center={center}
            zoom={zoom}
            bounds={bounds}
            setMapsLoaded={handleMapsLoaded}
            onCenterChanged={onCenterChanged}
        >
            {children}
        </MapBox>
    );
};

export default memo(MapboxView);
